import api from './api';

const aiAnalyticsService = {
  getAnalytics: async (params = {}) => {
    const response = await api.get('/main-dashboard/ai-analytics', { params });
    return response.data;
  }
};

export default aiAnalyticsService;
